// extracted by mini-css-extract-plugin
export var layoutContainer = "_d5-0";
export var layoutContainerNoRounding = "_d5-6";
export var layoutContainerOpen = "_d5-5";
export var layoutContainerResizing = "_d5-1";
export var mainContent = "_d5-2";
export var resizeDivider = "_d5-3";
export var slidePanel = "_d5-4";